/* 产品信息接口 */

import ajax from '../ajax';
import axios from 'axios';

export default {
  // 产品类别列表数据
  getProductCategoryList (params) {
    return ajax.postForm(
      '/loanform/base/loanBaseProduct/getProductCategoryList.ht',
      params
    );
  },

  // 产品列表数据
  getProductListData (params) {
    return ajax.postForm(
      '/loanform/base/loanBaseProduct/getProductList.ht',
      params
    );
  },
  getDetails (params) {
    return ajax.postForm('loanform/base/loanBaseProduct/getLoanProductDetail.ht', params);
  },

  isCurrentUserInBlacklist (params) { // 当前用户是否在黑名单内
    return axios.get('/mobile/item/loanItemFrontApply/checkCustomerIsBlack.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        productId: params.productId
      }
    });
  },
  getProductList (params) { // 获取产品列表
    return axios.get('/loanform/base/loanBaseProduct/getLoanProductList.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        pageCurrent: params.pageCurrent,
        proCategoryValue: params.proCategoryValue
      }
    });
  },

  getProductDetail (params) { // 获取产品详情
    return axios.get('/loanform/base/loanBaseProduct/getLoanProductDetail.ht', {
      params: {
        productId: params.productId
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/products/products.js